function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import React, { useContext } from "react";
import omit from "just-omit";
import { ImageContext, LinkContext } from "../../../context";
import { twMerge } from "../../../utils";
import { Body, Heading, Subheading } from "../../atoms";
export var TeamCardsCard = function(param) {
    var image = param.image, name = param.name, subtitle = param.subtitle, description = param.description, links = param.links, className = param.className;
    var ImageComponent = useContext(ImageContext).ImageComponent;
    var LinkComponent = useContext(LinkContext).LinkComponent;
    var cx = twMerge("isolate group", className);
    return /*#__PURE__*/ React.createElement("article", {
        className: cx
    }, /*#__PURE__*/ React.createElement("div", {
        className: "relative overflow-hidden w-full pb-[100%]"
    }, /*#__PURE__*/ React.createElement(ImageComponent, _extends({}, image, {
        className: "absolute top-0 left-0 w-full h-full"
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "pt-7 px-6"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max gap-6"
    }, /*#__PURE__*/ React.createElement(Heading, {
        as: "h4",
        variant: "h4"
    }, name), !!subtitle && /*#__PURE__*/ React.createElement(Subheading, {
        className: "text-brand-primary-base transition-all group-hover:text-brand-primary-light"
    }, subtitle), !!description && /*#__PURE__*/ React.createElement(Body, null, description)), !!(links === null || links === void 0 ? void 0 : links.length) && /*#__PURE__*/ React.createElement("div", {
        className: "mt-5 flex justify-start items-center"
    }, links.map(function(link) {
        return /*#__PURE__*/ React.createElement(LinkComponent, _extends({
            key: link.href
        }, omit(link, "icon"), {
            className: twMerge("flex items-center justify-center w-[1.2rem] h-[1.2rem] bg-brand-primary-base text-fg-inverted rounded-full mr-2", "transition-all hover:bg-brand-primary-light", "[&>svg]:w-[0.7rem] [&>svg]:h-auto", link.className)
        }), link.icon);
    }))));
};

//# sourceMappingURL=TeamCardsCard.js.map